<!--  -->
<template>
  <div class="detail-frame">
    <Content :routeArr="routeArr" />

    <!-- 详情展示 -->
    <div class="detail">
      <div class="detail-title">{{ detail.title }}</div>
      <div class="detail-time">
        发布时间:{{
          detail.publishTime ? detail.publishTime : detail.createTime
        }}
      </div>
      <div class="detail-detail" v-html="detail.contentStr"></div>

      <div class="other">
        <div class="pre" @click="preOne">
          <span class="symbol">&larr;</span> 上一篇
          <span class="preview"
            >:{{ preNew.id ? preNew.title : "已经是第一篇了" }}</span
          >
        </div>
        <div class="next" @click="nextOne">
          下一篇 <span class="symbol">&rarr;</span>
          <span class="preview"
            >:{{ nextNew.id ? nextNew.title : "已经是最后一篇了" }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import Content from "@/components/content.vue";
import { searchNewsinfo, getRecentNews } from "../../util/news/news.js";
export default {
  data() {
    return {
      isMobile: sessionStorage.getItem("isMobile"),
      routeArr: [],
      detail: {},
      preNew: {},
      nextNew: {},
      params: {
        pageIndex: 1,
        pageSize: 10,
        newsCode: "344f550f785643e7b40c2cd04dbe4a29",
      },
    };
  },
  components: { Content },
  created() {},
  mounted() {
    this.routeArr = [
      { name: "首页", path: "/" },
      { name: "新闻列表", path: "/news" },
      { name: "新闻详情" },
    ];
    searchNewsinfo(this.$route.query.id).then((res) => {
      this.detail = res.data;

      this.getRecent();
    });
  },
  methods: {
    getRecent() {
      this.params.pageIndex = this.$route.query.num;
      // 获取最近新闻 api
      getRecentNews({ ...this.params, newsId: this.detail.id }).then((res) => {
        this.getNewIng = false;
        this.preNew = res.data.last == null ? {} : res.data.last;
        this.nextNew = res.data.next == null ? {} : res.data.next;
      });
    },
    // 上一篇
    preOne() {
      if (this.preNew.id) {
        const query = {
          id: this.preNew.id,
          num: this.preNew.pageIndex,
        };
        this.$router.replace("/newDetail?" + qs.stringify(query));
        this.$router.go(0);
      }
    },
    // 下一篇
    nextOne() {
      if (this.nextNew.id) {
        const query = {
          id: this.nextNew.id,
          num: this.nextNew.pageIndex,
        };
        this.$router.replace("/newDetail?" + qs.stringify(query));
        this.$router.go(0);
      }
    },
  },
};
</script>

<style lang='scss' scoped>
@function pxToRem($args) {
  @return $args / 50 + rem;
}
.detail {
  width: 1200px;
  margin: 60px auto;
  .btn {
    width: fit-content;
    &:hover {
      cursor: pointer;
      color: $theme;
    }
    img {
      vertical-align: middle;
      width: 20px;
    }
  }
  .detail-title {
    font-size: 30px;
    color: #333333;
    text-align: center;
    line-height: 40px;
    margin-top: 30px;
  }
  .detail-time {
    font-size: 12px;
    color: #999999;
    text-align: center;
    line-height: 40px;
  }
  .detail-detail {
    min-height: 200px;
  }

  .other {
    font-size: 15px;
    margin-top: 20px;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    user-select: none;

    .symbol {
      display: none;
    }
    .pre,
    .next {
      max-width: 48%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;

      &:hover {
        cursor: pointer;
        color: $theme;
      }
    }
  }
}
@media (max-width: 1024px) {
  .detail {
    width: 100%;
    padding: 0 pxToRem(20);
    box-sizing: border-box;

    .detail-title {
      font-size: pxToRem(17);
      line-height: pxToRem(25);
    }

    .pre,
    .next {
      padding: pxToRem(6) pxToRem(18);
      border-radius: pxToRem(5);
      border: 1px solid #6c757d;
      color: #6c757d;

      .symbol {
        display: inline-block;
      }
      .preview {
        display: none;
      }
      &:hover {
        border-color: $theme;
      }
    }
  }
}
</style>
